import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import PredefinedPhrasesSetup from './PredefinedPhrasesSetup';
import { Size } from '../../../../Enums/Size.enum';
import { PhraseType } from '../../../../graphql/graphql';

interface Props extends BaseModalProps {
	onEdit?: () => void;
	type?: PhraseType;
}

const PredefinedPhrasesSetupModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='base.phrasesSetup' size={Size.FULLSCREEN}>
			<PredefinedPhrasesSetup type={props.type} onEdit={props.onEdit} />
		</BaseModal>
	);
};

export default PredefinedPhrasesSetupModal;
